export const Error = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
            <circle cx="16.8398" cy="16.7222" r="16" fill="#8D3A37" />
            <circle cx="16.8398" cy="16.7222" r="12" fill="#EC625C" />
            <rect x="20.8154" y="11.2222" width="2.4" height="13.3999" rx="1.2" transform="rotate(45 20.8154 11.2222)" fill="white" />
            <rect x="11.3408" y="12.9192" width="2.4" height="13.3999" rx="1.2" transform="rotate(-45 11.3408 12.9192)" fill="white" />
        </svg>
    );
};
